import { render, staticRenderFns } from "./expression-base.vue?vue&type=template&id=fdb23210&scoped=true"
import script from "./expression-base.vue?vue&type=script&lang=ts"
export * from "./expression-base.vue?vue&type=script&lang=ts"
import style0 from "./expression-base.vue?vue&type=style&index=0&id=fdb23210&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb23210",
  null
  
)

export default component.exports